import { Dispatch } from 'redux';
import request, { refreshSession } from '../../app/api/requests';
import { getAccessToken, getRefreshToken, getSessionEpoch } from '../../shared/lib/auth/session';
import { UserAuthActionTypes, UserAuthTypeAction } from './userStore';

export const FETCH_DATA_REQUEST_USER_ACCOUNT = 'FETCH_DATA_REQUEST_USER_ACCOUNT';
export const FETCH_DATA_RESPONSE_USER_ACCOUNT = 'FETCH_DATA_RESPONSE_USER_ACCOUNT';
export const FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR = 'FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR';
export const getUserData = () => async (dispatch: Dispatch<UserAuthTypeAction>) => {
    const epoch = getSessionEpoch();
    dispatch({type: UserAuthActionTypes.FETCH_DATA_REQUEST_USER_ACCOUNT});
    try {
        if (!getAccessToken() && getRefreshToken()) await refreshSession();
        if (epoch !== getSessionEpoch()) return;
        const response = await request.get('/Account/Me', {timeout: 15000});
        if (epoch !== getSessionEpoch()) return;
        const data = response.data;
        const userId = data?.id ?? data?.userId;
        if (typeof userId !== 'string' || !userId) throw new Error('Invalid current user response');
        localStorage.setItem('userID', userId);
        dispatch({type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT, payload: {
            ...data, userId, firstName: data.firstName ?? data.name, lastName: data.lastName ?? data.lastname,
            nickName: data.nickName ?? data.nickname, birthDay: data.birthDay ?? data.birthday,
        }});
    } catch {
        if (epoch === getSessionEpoch()) dispatch({
            type: UserAuthActionTypes.FETCH_DATA_RESPONSE_USER_ACCOUNT_ERR,
            payload: 'session_recovery_pending',
        });
    }
};
